import React, { Component } from "react";
import { DatePicker } from "/src/component/general/DatePicker";
import { formatDistanceToNowStrict } from "date-fns";
import EXIF from "exif-js";

import EntityDropdown from "../../component/EntityDropdown";
import Downloader from "../../component/general/Downloader/Downloader";
import { LazyLoading } from "../../component/general/LazyLoading";
import Loading from "../../component/Loading";
import PhotoTaskSlider from "../../component/PhotoTaskSlider";
import PointFilter from "../../component/PointFilter";
import { ENTITY_DROPDOWN_SETTINGS, PHOTO_REVIEW } from "../../config/lang";

import { classNames } from "../../util/classNames";
import { translate } from "../../util/util";

import "./style.scss";

class Table extends Component {
  constructor(props) {
    super(props);
    this.imgRefs = [];
    this.myGroupBtnRef = React.createRef();
    this.mySingleBtnRef = React.createRef();

    this.containerRefs = [];
    this.state = {
      overflowStates: [],
    };

    this.state = {
      loading: false,
      // Keyed by item.id (not array index) so state stays correct if the list is
      // ever reordered or trimmed (e.g. evicting old infinite-scroll pages) —
      // an index-keyed array would silently point at the wrong item after a shift.
      loadedImages: {},
      selectedImages: {},
      exportMode: false,
      isActiveAccordion: false,
      isIOS: false,
      imdData: [],
      photoIndex: 0,
      gridModeView: "single",
    };
  }

  componentDidMount() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    this.checkOverflow();

    if ((/iPad|iPhone|iPod|Macintosh|Mac OS/.test(userAgent) && !window.MSStream) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) {
      this.setState({ isIOS: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.checkOverflow();
    }
  }

  checkOverflow = () => {
    const { data } = this.props;
    if (Array.isArray(data)) {
      if (this.state.overflowStates?.length !== data.length) {
        this.setState({
          overflowStates: new Array(data.length).fill(false),
        });
      }

      const overflowStates = data.map((item, index) => {
        const container = this.containerRefs[index];
        return container && container.offsetWidth > 188;
      });

      this.setState({ overflowStates });
    }
  };

  loadPhotoReviewFull = id => {
    this.setState(prevState => ({
      loadedImages: { ...prevState.loadedImages, [id]: true },
    }));
  };

  loadProductsList = (event, entity) => {
    // event: Event, entity: string
    this.props.changeFilter(entity, event);
  };

  handleSelectedImages = (e, id, url) => {
    const checked = e.target?.checked;
    this.setState(prevState => ({
      selectedImages: { ...prevState.selectedImages, [id]: checked ? url : undefined },
    }));
  };
  handleExportMode = () => {
    this.setState(
      prevState => ({
        exportMode: !prevState.exportMode,
      }),
      () => {
        console.log("exportMode", this.state.exportMode);
      }
    );
  };

  handlerAccordion = () => {
    this.setState({ isActiveAccordion: !this.state.isActiveAccordion });
  };

  handleExImg = index => {
    let orientation = null;
    let thumbnail = null;

    const self = this;
    EXIF.getData(this.imgRefs[index], function() {
      orientation = EXIF.getTag(this, "Orientation");
      thumbnail = EXIF.getTag(this, "thumbnail");
      if (JSON.stringify(orientation) !== "6" && JSON.stringify(thumbnail?.Orientation) == "6") {
        self.setState(prevState => ({
          imdData: [...prevState.imdData, Number(index)],
        }));
      }
    });
  };

  checkIosImgInArr = index => {
    return [...new Set(this.state.imdData)].includes(Number(index)) ? true : false;
  };

  translate = (name, entity = ENTITY_DROPDOWN_SETTINGS) => {
    const lang = this.props.lang ? this.props.lang : "en";
    return translate(entity, name, lang);
  };

  handleGridChangeButtonClick = (e, type) => {
    // e.target.className += " btn-active";
    //reset loadedImages data before change view type
    if (this.state.gridModeView === type) return;
    e.target.closest(".switch-view").setAttribute("data-view-type", type);
    this.props.gridPhotoView(type);

    if (type === "single") {
      this.myGroupBtnRef.current.classList.remove("btn-active");
      this.mySingleBtnRef.current.classList.add("btn-active");
    } else {
      this.mySingleBtnRef.current.classList.remove("btn-active");
      this.myGroupBtnRef.current.classList.add("btn-active");
    }

    this.setState({ gridModeView: type, loading: true });
  };

  activePhotoIndex = (index = 0) => {
    this.setState({ photoIndex: index });
    return index;
  };

  render() {
    const {
      data,
      openTask,
      filter,
      changeFilter,
      resetFilter,
      createNewFilter,
      addNewFilterName,
      list,
      removeUserFilterPopup,
      acceptRejectAnswer,
    } = this.props;
    const { selectedImages, loadedImages, exportMode } = this.state;
    const { overflowStates } = this.state;

    return (
      <div className="row photo-review">
        <div className="md-filter-panel">
          {/* ── Row 1: date range + main dropdowns ── */}
          <div className="md-filter-grid">
            <div className="md-filter-field md-filter-field--dates">
              <span className="md-filter-label">{this.translate("date_range")}</span>
              <div className="md-filter-dates">
                <DatePicker selected={filter.start ? new Date(filter.start) : null} className="datePicker" onChange={date => changeFilter("start", date)} />
                <span className="md-filter-date-sep">—</span>
                <DatePicker selected={filter.end ? new Date(filter.end) : null} className="datePicker" onChange={date => changeFilter("end", date)} />
              </div>
            </div>

            <div className="md-filter-field md-filter-field-custom_filter">
              <span className="md-filter-label">{this.translate("custom_filter")}</span>
              <EntityDropdown entity="filters" value={filter?.filters?.id} updatedList={list} onChange={o => changeFilter("filters", o)} />
            </div>

            <div className="md-filter-field md-filter-field-clients">
              <span className="md-filter-label">{this.translate("clients")}</span>
              <EntityDropdown entity="clients" value={filter.clients} onChange={o => changeFilter("clients", o)} />
            </div>

            <div className="md-filter-field md-filter-field-merchandisers is-multi-field">
              <span className="md-filter-label">{this.translate("merchandisers")}</span>
              <EntityDropdown entity="merchandisers" value={filter.users} onChange={o => changeFilter("users", o)} isMulti />
            </div>

            <div className="md-filter-field md-filter-field-network">
              <span className="md-filter-label">{this.translate("network")}</span>
              <EntityDropdown entity="network" value={filter.point__network} onChange={o => changeFilter("point__network", o)} />
            </div>
          </div>

          {/* ── Row 2: region + points ── */}
          <div className="md-filter-grid md-filter-grid--point">
            <span className="md-filter-label">{this.translate("region")}</span>
            <PointFilter
              saveValue={filter.county}
              value={filter.points}
              onChange={o => changeFilter("points", o)}
              onChangeRegion={o => changeFilter("county", o)}
              isMulti
              moduleFilter={filter.point__network}
            />
          </div>

          {/* ── Additional filters (expandable) ── */}
          <div className="md-filter-section">
            <button className="md-filter-section-toggle" onClick={this.handlerAccordion}>
              <span className="md-nav-icon">{this.state.isActiveAccordion ? "expand_less" : "expand_more"}</span>
              {this.translate("additional_filters")}
            </button>

            {this.state.isActiveAccordion && (
              <div className="md-filter-grid md-filter-grid--extra">
                <div className="md-filter-field">
                  <EntityDropdown entity="categories" value={filter?.categories} onChange={o => changeFilter("categories", o)} isMulti />
                </div>
                <div className="md-filter-field">
                  <EntityDropdown entity="subcategories" value={filter?.subcategories} onChange={o => changeFilter("subcategories", o)} isMulti />
                </div>
                <div className="md-filter-field">
                  <EntityDropdown entity="brands" value={filter?.brands} onChange={o => changeFilter("brands", o)} isMulti />
                </div>
                <div className="md-filter-field">
                  <EntityDropdown entity="products" value={filter?.products} asynch onChange={o => this.loadProductsList(o, "products")} isMulti />
                </div>
                <div className="md-filter-field">
                  <EntityDropdown entity="tags" value={filter?.tags} onChange={o => changeFilter("tags", o)} isMulti />
                </div>
                <div className="md-filter-field md-filter-field-comment">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={this.translate("comment")}
                    value={filter.comment}
                    onChange={e => changeFilter("comment", e.target.value)}
                  />
                </div>
              </div>
            )}
          </div>

          {/* ── Action bar ── */}
          <div className="md-filter-actions">
            <div className="md-filter-actions-left">
              <button className="btn btn-primary" onClick={this.props.submit}>
                {this.translate("apply")}
              </button>
              <button className="btn btn-outline-primary" onClick={resetFilter}>
                {this.translate("filter_reset")}
              </button>
              {this.state.gridModeView === "single" && (
                <Downloader
                  options={{
                    url: data[0]?.photo,
                    urls: data?.map(img => img.photo[0]),
                    selectedImages: Object.values(selectedImages || {}).filter(url => !!url),
                    disabled: !Object.keys(loadedImages || {}).length,
                    handleExportMode: this.handleExportMode,
                    exportMode,
                  }}
                />
              )}
              {filter.isChange && (
                <div className="md-filter-save">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={this.translate("filter_name_placeholder")}
                    value={filter?.newFilter}
                    onChange={e => addNewFilterName(e.target.value)}
                  />
                  <button className="btn btn-outline-primary" onClick={() => createNewFilter("filters", filter?.newFilter)}>
                    {this.translate("filter_save")}
                  </button>
                  <button className="btn btn-danger" onClick={() => removeUserFilterPopup("filters")}>
                    {this.translate("filter_remove")}
                  </button>
                </div>
              )}
            </div>
            <div className="md-filter-actions-right">
              <label htmlFor="photo-filter-view" className="switch-view" data-view-type={this.state.gridModeView} aria-label="Toggle Photo Filter">
                <span className="switch-btn" ref={this.mySingleBtnRef} onClick={e => this.handleGridChangeButtonClick(e, "single")}>
                  {this.translate("photo_review_type_single")}
                </span>
                <span className="switch-btn" ref={this.myGroupBtnRef} onClick={e => this.handleGridChangeButtonClick(e, "group")}>
                  {this.translate("photo_review_type_group")}
                </span>
              </label>
            </div>
          </div>
        </div>
        <div className="photo-review-list-wrap">
          <Loading loading={this.props.loading} disP={true} />
          <div className="col-md-12 p-4 photo-review-list">
          {data.map((item, index) => {
            const tagValues = Array.isArray(item?.additional_info?.tags) ? item.additional_info.tags : [];

            const hasLocation = !!(item?.visit?.point?.locality?.name || item?.visit?.point?.name);
            const hasUser = !!(item?.visit?.user?.first_name || item?.visit?.user?.last_name);
            const hasInfo = hasLocation || tagValues.length > 0 || hasUser;

            const openItem = e => {
              if (loadedImages[item.id] && !exportMode) openTask(item, false, 0);
            };

            return (
              <div
                key={index}
                className={`photo-review-item${exportMode ? " photo-review-item--export-mode" : ""}${
                  index === this.props.currentIndex ? " photo-review-item--active" : ""
                }${!hasInfo ? " photo-review-item--full-image" : ""}`}
                title={`/photo-review/${item.id}/view`}>
                <div className="root-container">
                  <Loading loading={!loadedImages?.[item.id]} disP={true} />
                  <div className={classNames("photo-review-item-wrapper", index === this.props.currentIndex && "photo-review-item-wrapper--active")}>
                    <PhotoTaskSlider
                      activePhotoIndex={this.activePhotoIndex}
                      photos={item.photo}
                      clickCallback={photoIndex => {
                        if (loadedImages[item.id] && !exportMode) {
                          openTask(item, false, photoIndex);
                        }
                      }}
                      isDeepArray={true}
                      loadPhotoReviewFn={() => this.loadPhotoReviewFull(item.id)}
                      viewMode={this.state.gridModeView}
                    />
                    {this.state.gridModeView === "single" ? (
                      <div className="card-action-overlay single-details-buttons">
                        <button
                          className={`card-action-btn card-action-btn--approve${item.approval?.is_approved === true ? " card-action-btn--active" : ""}`}
                          title={this.translate("approv_btn", PHOTO_REVIEW)}
                          onClick={() => {
                            acceptRejectAnswer("ACCEPT", item, true);
                          }}>
                          <span className="material-symbols-outlined">check_circle</span>
                        </button>
                        <button
                          className={`card-action-btn card-action-btn--reject${item.approval?.is_approved === false ? " card-action-btn--active" : ""}`}
                          title={this.translate("reject_btn", PHOTO_REVIEW)}
                          onClick={() => {
                            openTask(item, true, 0);
                          }}>
                          <span className="material-symbols-outlined">cancel</span>
                        </button>
                      </div>
                    ) : null}
                    {this.state.gridModeView === "group" ? (
                      <div className="card-action-overlay">
                        <button
                          className={`card-action-btn card-action-btn--approve${item.approval?.is_approved === true ? " card-action-btn--active" : ""}`}
                          onClick={() => {
                            acceptRejectAnswer("ACCEPT", item, true);
                          }}
                          title={this.translate("approv_btn", PHOTO_REVIEW)}>
                          <span className="material-symbols-outlined">check_circle</span>
                        </button>
                        <button
                          className={`card-action-btn card-action-btn--reject${item.approval?.is_approved === false ? " card-action-btn--active" : ""}`}
                          onClick={() => {
                            if (loadedImages[item.id] && !exportMode) {
                              openTask(item, true, this.state.photoIndex);
                            }
                          }}
                          title={this.translate("reject_btn", PHOTO_REVIEW)}>
                          <span className="material-symbols-outlined">cancel</span>
                        </button>
                      </div>
                    ) : null}

                    {/* Status badge overlaid on image when no info panel */}
                    {!hasInfo && item.approval?.is_approved != null && (
                      <div className={`status-square status-square--overlay ${item.approval.is_approved === true ? "approved" : "rejected"}`}>
                        {item.approval.is_approved === true ? "✔" : "✖"}
                      </div>
                    )}
                  </div>

                  {hasInfo && (
                    <>
                      <div className="review-item" onClick={openItem}>
                        <div className="review-item-text">
                          {item?.visit?.point?.locality?.name && <p className="photo-review-item-content first-item">{item.visit.point.locality.name}</p>}
                          {item?.visit?.point?.name && <p className="photo-review-item-content">{item.visit.point.name}</p>}
                        </div>
                        {item.approval?.is_approved != null ? (
                          <div className={`status-square ${item.approval.is_approved === true ? "approved" : "rejected"}`}>
                            {item.approval.is_approved === true ? "✔" : "✖"}
                          </div>
                        ) : null}
                      </div>

                      {tagValues.length > 0 && (
                        <div className="tags-form-group tags-group-content" onClick={openItem}>
                          <div className="tags-scroll" ref={el => (this.containerRefs[index] = el)}>
                            {tagValues.map((tag, idx) => (
                              <span key={idx} className="tag-label">
                                {tag}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}

                      {hasUser && (
                        <div className="visit-info" onClick={openItem}>
                          <span className="user-name">
                            {item?.visit?.user?.first_name} {item?.visit?.user?.last_name}
                          </span>
                          <span className="time-elapsed">
                            {item?.visit?.start ? formatDistanceToNowStrict(new Date(item.visit.start), { addSuffix: true }) : ""}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {exportMode && (
                  <label className="photo-review-item-to-download">
                    <input
                      type="checkbox"
                      name={`photo-review-selected[${item.id}]`}
                      className="form-filter-checkbox"
                      checked={!!selectedImages[item.id]}
                      value={selectedImages[item.id] || ""}
                      onChange={e => {
                        this.handleSelectedImages(e, item.id, item.photo[0]);
                      }}
                    />
                  </label>
                )}
              </div>
            );
          })}
          </div>
        </div>

        {this.props.loadingMore && (
          <div className="photo-review-loading-more">
            <i className="fa fa-spinner fa-pulse fa-2x fa-fw" />
          </div>
        )}

        {!this.props.loading && !this.props.loadingMore && (
          <>
            <LazyLoading
              loading={false}
              onScroll={async () => {
                this.props.updatePaging();
              }}
            />
          </>
        )}
      </div>
    );
  }
}

export default Table;